import React, { useEffect } from "react";
//import { useSearchParams } from "react-router-dom";
import useRouting from "../hooks/useRouting";
import Header from "./Header";
import { trackEvent } from "../utils/trackEvent";
import "./ErrorPage.css";

const ErrorPage = () => {
  //const [searchParams] = useSearchParams();
  const { navigateBack } = useRouting();

  // Get error message from URL params or localStorage
  // const errorMessage = searchParams.get("message") ||
  //                      localStorage.getItem("errorMessage") ||
  //                      "An error occurred. Please try again.";

  useEffect(() => { trackEvent("loan_error_viewed"); }, []);

  // Clear error message from localStorage after reading
  useEffect(() => {
    localStorage.removeItem("errorMessage");
  }, []);

  const handleBack = () => {
    trackEvent("loan_error_retry_clicked");
    // Navigate back to employment details page
    navigateBack("employment-details");
  };

  return (
    <div className="loan-container">
      <Header showBackButton={true} onBackClick={handleBack} />
      
      <div className="main-content">
        <div className="error-page-content">
          <div className="error-icon-large">⚠️</div>
          <h1 className="error-title-large">No loan offer available</h1>
          {/* <p className="error-message">{errorMessage}</p> */}
          <p className="error-message">Based on your profile, none of our lender partners are able to issue a loan at this time.</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

